import type { StorageInterface } from "@niutraan/hooks";

// Web implementation using localStorage
export const WebStorage: StorageInterface = {
  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key);
  },

  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  },

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key);
  },

  async hasItem(key: string): Promise<boolean> {
    const value = localStorage.getItem(key);
    return value !== null;
  },
};
